import './notification-item.component.scss'
import {
    CalculationNotificationServiceName,
    OpportunityNotificationToggleServiceName
} from "../../../utils/names/serviceNames";
import {CalculationsNotificationService} from "../../../opportunities_service/service/CalculationsNotificationService";
import {OpportunityNotificationToggleService} from "../../service/OpportunityNotificationToggleService";
import {IHttpResponse, IScope} from "angular";

export interface NotificationCountScope extends IScope {
    hideNotifications: () => void;
    notificationsCount: number;
    showNotification: boolean;
    enableNotification: boolean;
    toggleNotificationList: () => void;
    activateCounter: boolean;
}

export class NotificationItemComponent {

    public static instance = {
        template: require('./notification-item.component.html'),
        controller: [
            '$scope',
            CalculationNotificationServiceName,
            OpportunityNotificationToggleServiceName,
            NotificationItemComponent
        ],
        controllerAs: '$ctrl',
        bindToController: true,
        bindings: {
            notificationsCount: '=',
            enableNotification: '=',
            showNotification: '=',
            toggleNotificationList: '=',
            hideNotifications: '=',
            activateCounter: '='
        }
    };

    constructor(private $scope: NotificationCountScope,
                private notificationService: CalculationsNotificationService,
                private toggleService: OpportunityNotificationToggleService) {
        this.$scope.activateCounter = false;
        this.$scope.enableNotification = false;
        this.$scope.toggleNotificationList = this.toggleService.toggle;
        this.toggleService.getToggleValueObservable().subscribe(next =>this.$scope.showNotification = next);
        this.notificationService.getNumberOfNotificationsObservable().subscribe(next => this.$scope.notificationsCount = next);
        this.$scope.hideNotifications = this.hideNotifications;
        this.notificationService.getNumberOfNotifications()
            .then(this.handleNotificationsCountResponse);
    }

    private hideNotifications: () => void;

    private handleNotificationsCountResponse = (resp: IHttpResponse<number>) => {
        if (resp.status == 200) {
            let notificationsCount = resp.data;
            this.handleNotificationsCountUpdate(notificationsCount);
        }
    };

    private handleNotificationsCountUpdate = (notificationsCount: number) => {
        this.$scope.notificationsCount = notificationsCount;
        this.$scope.enableNotification = notificationsCount > 0;
        this.$scope.activateCounter = true;
    };

}